export const LANGUAGE_STATE = 'language'
export const THEME_STATE = 'theme'
export const USER_STATE = 'user'